//import { ZoomMtg } from "@zoomus/websdk";

export default class ZoomBinar {
  constructor(
    params = {
      zoomSelector: "",
      meetConfig: {
        signatureUrl: "",
        apiKey: "s3tJ1CemNpO4GmRFIa3TjwtGFbYe2q1ABOJV",
        meetingNumber: "123456789",
        leaveUrl: "https://yoursite.com/meetingEnd",
        userName: "Firstname Lastname",
        userEmail: "firstname.lastname@yoursite.com", // required
        passWord: "", // if required
        role: 0, // 1 for host; 0 for attendee
      },
    }
  ) {
    this.zoomSelector = params.zoomSelector;
    this.zoomElem = null;

    this.meetConfig = params.meetConfig;

    //hide zoom default
    this.root = document.querySelector("#zmmtg-root");

    if (this.root) {
      this.root.classList.add("hide");
    }
  }

  init() {
    this.zoomElem = document.querySelector(this.zoomSelector);

    if (this.zoomElem) {
      this.root.classList.remove("hide");

      ZoomMtg.preLoadWasm();
      ZoomMtg.prepareJssdk();

      this.getSignature();
    }
  }

  getSignature() {
    // make a request for a signature
    fetch(this.meetConfig.signatureUrl, {
      method: "POST",
      body: JSON.stringify({ meetingData: this.meetConfig }),
    })
      .then((result) => result.json())
      .then((response) => {
        // call the init method with meeting settings
        ZoomMtg.init({
          leaveUrl: this.meetConfig.leaveUrl,
          isSupportAV: true,
          // on success, call th console.log();
          success: () => {
            ZoomMtg.join({
              // pass your signature response in the join method
              signature: response.signature,
              apiKey: this.meetConfig.apiKey,
              meetingNumber: this.meetConfig.meetingNumber,
              userName: this.meetConfig.userName,
              userEmail: this.meetConfig.userEmail,
              passWord: this.meetConfig.passWord,
              // on success, get the attendee list and verify the current user
              success: function (res) {
                /*console.log("join meeting success");
                                console.log("get attendee list");
                                ZoomMtg.getAttendeeslist({});
                                ZoomMtg.getCurrentUser({
                                    success: function (res) {
                                        console.log("success getCurrentUser", res.result.currentUser);
                                    }
                                });*/
              },
              error: (res) => {
                console.log(res);
              },
            });
          },
        });
      });

    /*ZoomMtg.init({
      leaveUrl: this.meetConfig.leaveUrl,
      isSupportAV: true,
      // on success, call the join method
      success: () => {
        ZoomMtg.join({
          // pass your signature response in the join method
          signature: signature,
          apiKey: this.meetConfig.apiKey,
          meetingNumber: this.meetConfig.meetingNumber,
          userName: this.meetConfig.userName,
          passWord: this.meetConfig.passWord,
          // on success, get the attendee list and verify the current user
          success: function (res) {
            /*console.log("join meeting success");
                              console.log("get attendee list");
                              ZoomMtg.getAttendeeslist({});
                              ZoomMtg.getCurrentUser({
                                  success: function (res) {
                                      console.log("success getCurrentUser", res.result.currentUser);
                                  }
                              });*/
    /*},
          error: (res) => {
            console.log(res);
          },
        });
      },
    });*/
  }
}
